<template>
  <div id="app" @keydown="handleKeydown">
    <div class="left"></div>

    <config v-if="showConfig"
            :config="config"
            @ok="applyConfig"
            @cancel="showConfig = false" />

    <div class="contents">
      <div class="header">
        <div class="logo">
          <a href="https://tttimestamps.com">
            <img src="/static/img/tttimestamps_logo.svg" width="250" height="40" alt="tttimestamps">
          </a>
        </div>

        <div class="menu">
          <!-- facebook like button (Facebook SDK is loaded in index.html) -->
          <div class="social facebook">
            <div class="fb-like" data-href="https://tttimestamps.com" data-layout="button" data-action="like" data-size="small" data-show-faces="false" data-share="false"></div>
          </div>

          <!-- tweet button (Twitter SDK is loaded in index.html) -->
          <div class="social twitter">
            <a class="twitter-share-button"
               href="https://twitter.com/intent/tweet?text=Check%20out%20this%20handy%20timestamp%20converter"
               data-size="small">
              Tweet</a>
          </div>

          <!-- tttimestamps help -->
          <button type="button"
                  class="actions help"
                  title="Help on tttimestamps"
                  @click="handleShowHelp" ></button>

          <!-- tttimestamps configuration -->
          <button type="button"
                  class="actions config"
                  title="Configure tttimestamps"
                  @click="showConfig = true" ></button>

        </div>
      </div>

      <time-table
          :descriptions="config.descriptions !== false"
          :columns="columnsWithDefinitions"
          :showHelp="showHelp"
          @showConfig="showConfig = true"
          @hideHelp="handleHideHelp"></time-table>

      <div id="footer">
        <div id="footer-inner">
          <a href="https://tttimestamps.com" class="footer">tttimestamps {{version}}</a>
          •
          <a href="/static/history.html" class="footer">history</a>
          •
          made with love by <a href="http://josdejong.com">Jos de Jong</a>
        </div>
      </div>
    </div>
    <div class="right"></div>
  </div>
</template>

<script>
import './App.scss'
import moment from 'moment-timezone'
import assign from 'lodash/assign'
import TimeTable from './components/TimeTable'
import { DEFINITIONS } from './tttime/tttime.js'
import Config from './components/Config'
import { version } from '../package.json'

const CONFIG_KEY = 'config'

// expose moment.js for the real diehard developers :)
window.moment = moment

export default {
  name: 'app',

  components: {
    TimeTable,
    Config
  },

  data: function () {
    const showHelp = ('showIntro' in window.localStorage)
        ? (window.localStorage['showHelp'] === 'true')
        : !('timestamps' in window.localStorage)

    return {
      version,
      config: loadConfig(),
      showConfig: false,
      showHelp
    }
  },

  computed: {
    columnsWithDefinitions: function () {
      return this.config.columns.map(column => {
        const definition = DEFINITIONS[column.type]
        return assign({ definition }, column)
      })
    }
  },

  methods: {
    applyConfig: function (newConfig) {
      this.config = newConfig
      this.showConfig = false
    },

    handleKeydown: function (event) {
      if (event.keyCode === 27 && this.showConfig) { // ESC
        this.showConfig = false
      }
    },

    handleShowHelp: function () {
      this.showHelp = true
      window.localStorage['showHelp'] = 'true'
    },

    handleHideHelp: function () {
      this.showHelp = false
      window.localStorage['showHelp'] = 'false'
    }
  },

  watch: {
    config: function (config) {
      saveConfig(config)
    },
    showConfig: function (showConfig) {
      document.querySelector('body').className = showConfig ? 'no-scroll' : ''
    }
  }
}

function saveConfig (config) {
  window.localStorage.setItem(CONFIG_KEY, JSON.stringify(config))
}

function loadConfig () {
  const stringifiedConfig = window.localStorage.getItem(CONFIG_KEY)
  if (stringifiedConfig) {
    try {
      const config = JSON.parse(stringifiedConfig)
      if (validConfig(config)) {
        return config
      } else {
        console.error('Invalid config', stringifiedConfig)
      }
    } catch (err) {
      console.error('Failed to parse config from localStorage', stringifiedConfig)
    }
  }

  // return default config
  return {
    descriptions: true,
    columns: Config.DEFAULT_COLUMN_DEFINITIONS
  }
}

/**
 * Test whether a config object is valid
 */
function validConfig (config) {
  return config &&
      config.columns &&
      Array.isArray(config.columns) &&
      config.columns.length > 0 &&
      config.columns.every(column => {
        return DEFINITIONS[column.type] !== undefined
      })
}

// Override the following moment.js deprecation warning:
// Deprecation warning: value provided is not in a recognized ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.
const originalWarn = console.warn.bind(console)
console.warn = function (...args) {
  if (/Deprecation warning: value provided is not in a recognized ISO format/.test(args[0])) {
    // ignore this deprecation warning...
  } else {
    originalWarn(...args)
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?0b095d94